import { render, staticRenderFns } from "./stoffklassen.vue?vue&type=template&id=a0fd26b8&scoped=true&"
import script from "./stoffklassen.vue?vue&type=script&lang=js&"
export * from "./stoffklassen.vue?vue&type=script&lang=js&"
import style0 from "./stoffklassen.vue?vue&type=style&index=0&id=a0fd26b8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fd26b8",
  null
  
)

export default component.exports